export { bodyBold } from './BodyBoldText.styles';
export type { BodyBoldMixinProps } from './BodyBoldText.styles';
export { BodyBoldText } from './BodyBoldText';
